/*
 * File: FormStore.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: The whole form model.  Contains an array of fields
 */
import { types, getSnapshot } from "mobx-state-tree";
import FormModel from "./models/FormModel";

const FormStore = types
  .model("FormStore", {
    /**
     * @var {Array} inputs: Form field inputs
     */
    fields: types.array(FormModel),
    formError: types.maybe(types.string),
    errorMessage: types.maybe(types.string)
  })

  .actions(self => ({
    /**
     * Called from the component to validate a form submission
     *
     * @param {Object} data: data submitted from the form
     */

    validateAllFields(data) {
      // iterate over fields to validate
      self.fields.forEach(field => {
        field.validateFieldForSubmit(data);
      });
    },

    setFormError(formError, errorMessage) {
      self.formError = formError;
      self.errorMessage = errorMessage;
    },

    setFields(fields) {
      self.fields = fields;
    }
  }))

  .views(self => ({
    /**
     * Return a serialized array of the store fields
     *
     * @return {Array}
     */

    getFields() {
      return getSnapshot(self.fields);
    },

    getFieldByName(name) {
      return self.fields.find(field => field.name === name);
    },

    /**
     * Called from component to handle submission when the data is valid
     *
     * @return {Boolean}
     */

    isValid() {
      if (
        self.fields.filter(f => f.errorMessage).length === 0 &&
        !self.formError
      ) {
        return true;
      }
      return false;
    }
  }));

export default FormStore;
